// extracted by mini-css-extract-plugin
module.exports = {"go-back-button":"style_go-back-button__82ioc","go-back-button__link":"style_go-back-button__link__8Nr5A","go-back-button__icon":"style_go-back-button__icon__suHbX"};